import * as Sentry from '@sentry/browser'

async function initBraintree() {
  let clientToken: string

  try {
    const tokenResponse = await fetch('/api/braintree_token.ashx')
    clientToken = await tokenResponse.text()
  } catch (e) {
    // Do not log to sentry if navigation aborted the request
    if (e instanceof DOMException && e.name === 'AbortError') return

    console.error(e)
    Sentry.captureException(e)
    return
  }

  try {
    // @ts-ignore
    const clientInstance = await braintree.client.create({
      authorization: clientToken,
    })

    // @ts-ignore
    let paypalCheckoutInstance = await braintree.paypalCheckout.create({
      client: clientInstance,
    })

    await paypalCheckoutInstance.loadPayPalSDK({
      vault: true,
    })

    // @ts-ignore
    await paypal
      .Buttons({
        // @ts-ignore
        fundingSource: paypal.FUNDING.PAYPAL,

        style: {
          color: 'white',
          height: 55,
        },

        createBillingAgreement: function () {
          console.log('createBillingAgreement')

          const plan = window['FinvizElitePlanSelected']
          const billingAgreementDescription =
            'FINVIZ*Elite ' + (plan === 'monthly' ? '$39.50 USD for each month' : '$299.50 USD for each year')

          return paypalCheckoutInstance.createPayment({
            flow: 'vault', // Required

            // The following are optional params
            billingAgreementDescription: billingAgreementDescription,
            enableBillingAddress: true,
          })
        },

        onApprove: function (data: any, actions: any) {
          console.log('onApprove')
          console.log(data, actions)
          return paypalCheckoutInstance.tokenizePayment(data).then(function (payload: any) {
            console.log('tokenize payment')
            console.log(payload)
            // Submit `payload.nonce` to your server
            let planId = window['FinvizElitePlanSelected'] === 'monthly' ? 'elite_monthly' : 'elite_yearly'

            let formData = new FormData()
            formData.append('nonce', payload.nonce)
            formData.append('plan_id', planId)

            fetch('/api/braintree_tx.ashx', {
              body: formData,
              method: 'post',
            }).then(() => {
              document.location.href = '/elite_autoreturn.ashx'
            })
          })
        },

        onCancel: function (data: any) {
          console.log('PayPal payment canceled', JSON.stringify(data, null, 2))
        },

        onError: function (err: any) {
          console.error('PayPal error', err)
          Sentry.captureException(err)
        },
      })
      .render('#js-paypal-button')
  } catch (err) {
    console.error(err)
    Sentry.captureException(err)
  }
}

initBraintree()

export {}
